import axios from "axios";
import { getCookies, deleteCookies, setCookies } from "./utils";
import { toast } from "react-toastify";
import eventEmitter from "../events/eventEmitter";

export const apiURL = process.env.REACT_APP_API_URL;

let store;

export const injectStore = (_store) => {
  store = _store;
};

export const recaptchaKey = "";

export const api = axios.create({
  baseURL: apiURL,
});



api.defaults.headers = {
  "Access-Control-Allow-Origin": `*`,
  "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE,PATCH,OPTIONS",
  "Content-Type": "application/json; charset=utf-8",
  Accept: "*/*",
};

api.interceptors.request.use(
  function (config) {
    const token = getCookies("betfrenzy_token");

    if (store) {
      const state = store.getState();
      const location = state?.location?.locationData;

      if (location) {
        config.headers["X-User-Location"] = JSON.stringify(location);
      }
    }

    config.headers.Authorization = `Bearer ${token}`;
    config.headers["Cache-Control"] = "no-cache, no-store, must-revalidate";
    config.headers["Pragma"] = "no-cache";
    config.headers["Expires"] = "0";
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

let redirecting = false;

api.interceptors.response.use(
  function (response) {
    return response;
  },

  async function (error) {

    const status = error?.response?.status;

    const message = error?.response?.data?.message;
    console.log(65, 69, error)


    if (status == 401) {
      deleteCookies("betfrenzy_token");
      setCookies("come_from_login", "yes");

      setTimeout(() => {
        sessionStorage.setItem("fromLogin", "true");
        const data = { ref: "dashboard" };
        const query = new URLSearchParams(data).toString();
      }, 1000);
    } else if (status == 400) {
      if (message == "No token provided.") {
        deleteCookies("betfrenzy_token");
        sessionStorage.setItem("fromLogin", "true");
        window.location.href = "/";
      }
      if (message == "Missing user location header.") {
        eventEmitter.emit("missingLocation");
      } else {
        toast.error(message || "Bad Request");
      }
    } else if (status == 403) {
      eventEmitter.emit("locationBlocked", message);
    } else if (status == 404) {
      toast.error(
        error.response.data?.error ||
        error.response.data?.message ||
        "Not Found"
      );
    } else if (status == 410 || status == 409) {
      deleteCookies("betfrenzy_token");

      sessionStorage.clear();
      localStorage.clear();

      sessionStorage.setItem("fromLogin", "true");

      toast.error(message);

      setTimeout(() => {
        window.location.href = "/";
      }, 1000);
    } else if (status === 500) {
      toast.error(message || "Bad Request");
    }

    return Promise.reject(error);
  }
);

export default api;
